import { createContext, useContext } from "react";

export interface IPayoutsModalContext {
  openPayoutsModal: (data: any) => void;
}

export const PayoutsModalContext = createContext<IPayoutsModalContext>({
  openPayoutsModal: () => {},
});

export const usePayoutsModalContext = () => useContext(PayoutsModalContext);
